export default function stripWhitespace(input: string = ''): string {
  if (typeof input !== 'string') {
    return input;
  }

  return input.replace(/[\n\r\s]/g, '');
}
